export class WebDFUError extends Error { }